module.exports = __webpack_public_path__ + "static/media/vector-4963.6159d02a.svg";